{
	"errorPage.404.button": "Retour à l'accueil",
	"errorPage.404.code": "Erreur 404",
	"errorPage.404.description": "Désolé, la page que vous recherchez n’existe pas ou a été déplacée.",
	"errorPage.404.title": "Page introuvable...",
	"errorPage.network.description": "Impossible de charger la page.\nVérifiez votre connexion internet et réessayez.",
	"errorPage.network.title": "Une erreur s’est produite…",
	"global.refreshButton": "Réessayer",
	"global.toast.error.message": "Une erreur s’est produite, veuillez réessayer.",
	"global.toast.error.title": "Erreur"
}

